export const enum WebapiRole {
  Admin = 'admin',
  TerminalWorker = '* terminal worker',
  OperationsAdministrator = '* operations administrator',
}
